import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when IS_SYNCATOR_API_ENABLED is set to "true" on the
// server (NSAI-4268). UI-only flag — the /syncator API and key-management
// endpoints stay reachable regardless; this hook just controls whether the
// Syncator API keys tab is surfaced in organization settings.
export const useSyncatorApiEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.features.isSyncatorApiEnabled ?? false;
};
